// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-vote__tip{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);padding:5px 16px;font-size:16px;line-height:22px;color:#fff;background-color:rgba(0,0,0,.6);border-radius:2px;white-space:nowrap}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
